import React from 'react';
import { Tag } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { HiExclamationTriangle, HiLockClosed } from 'react-icons/hi2';
import { FiCheck } from 'react-icons/fi';

export default function UserStatus({ status }: { status: string }) {
    const getStatusConfig = (status: string) => {
        switch (status) {
            case 'owner':
                return {
                    icon: <LockOutlined className="text-gray-600" />,
                    text: 'Owner',
                    className: 'bg-gray-50 border-gray-200 text-gray-700',
                };
            case 'waiting':
            case 'pending':
                return {
                    icon: (
                        <HiExclamationTriangle
                            className="text-[#F29100]"
                            size={20}
                        />
                    ),
                    text: status.charAt(0).toUpperCase() + status.slice(1),
                    className: 'bg-orange-50 border-orange-200 text-orange-700',
                };
            case 'joined':
            case 'active':
            case 'success':
                return {
                    icon: <FiCheck size={20} className="text-green-600" />,
                    text: status.charAt(0).toUpperCase() + status.slice(1),
                    className: 'bg-green-50 border-green-200 text-green-700',
                };
            default:
                return {
                    icon: <HiLockClosed size={20} className="text-gray-600" />,
                    text: 'Owner',
                    className: 'bg-gray-50 border-gray-200 text-gray-700',
                };
        }
    };

    const config = getStatusConfig(status);

    if (!config) return null;

    return (
        <Tag
            icon={config.icon}
            className={`${config.className} px-3 py-1 rounded-md text-[16px] flex items-center gap-1 w-fit`}
        >
            {config.text}
        </Tag>
    );
}
